import { TableRow as OriginalTableRow } from "@tiptap/extension-table";

import type { TableRowOptions } from "@tiptap/extension-table";

export const TableRow = OriginalTableRow.extend<TableRowOptions>({
  addAttributes() {
    return {
      ...this.parent?.(),
      height: {
        default: null,
        renderHTML: (attributes) => {
          if (!attributes.height) {
            return {};
          }

          return {
            style: `height: ${attributes.height}px;`,
          };
        },
      },
    };
  },

  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "h-full group/row",
      },
    };
  },
});
